import React, {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {PolicyTreePage} from '../modules/policy/PolicyTree'
//import UserInfo from '../modules/Webcam/UserInfo'

export function PrivateRoutes() {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const newMessagePage = lazy(() => import('../modules/message/components/NewMessagePage'))
  const configurationPage = lazy(() => import('../modules/configuration/components/AddressBookPage'))
  const inboxPage  = lazy(() => import('../modules/inbox/InboxPage'))
  const outboxPage  = lazy(() => import('../modules/outbox/OutboxPage'))
 // const WebCamPage = lazy(() => import('../modules/Webcam/WebcamComponent'))
//  const UserInfo = lazy(() => import('../modules/Webcam/UserInfo'))
  const sentItems = lazy(() => import('../modules/sentItems/SentItemsPage'))
  const sentItem = lazy(() => import('../modules/sentItems/SentItemPage'))
  const preference = lazy(() => import('../modules/preference/components/Preference'))
  const profile =lazy(() => import('../modules/preference/components/Profile'))
  const packages =lazy(() => import('../modules/preference/components/Packages'))
  const IdealTimer = lazy(() => import('../modules/auth/components/IdleTimerContainer'))
  const Reports = lazy(() => import('../modules/reports/components/Reports'))
/*  const files = lazy(() => import('../modules/files/Files.tsx'))
  const filecurrent = lazy(() => import('../modules/files/FileCurrent.tsx'))
  const fileprevious = lazy(() => import('../modules/files/FilePrevious.tsx'))
  const filedetails =  lazy(() => import('../modules/files/FileDetails.tsx')) */
  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/ghfjhgkjehdowefjwlekjfljewljflwkjfkjhefhfjkhf' component={DashboardWrapper} /> 
        <Route path='/preference' component={preference}/>
        <Route path='/profile' component={profile}/>
        <Route path='/packages' component={packages}/>
        <Route path ='/newMessage/normalMessage' component={newMessagePage} />
        <Route path='/inbox' component={inboxPage} />
        <Route path='/outbox' component={outboxPage} />
        <Route path ='/configuration/addressBook' component={configurationPage} />
        <Route path='/sentItems' component={sentItems} />
	<Route path='/sentItem' component={sentItem} />
        <Route path='/idelTimer/logout' component={IdealTimer} />  
        <Route path='/reports/summaryReports' component={Reports} />
        {/*<Redirect from='/auth' to='/dashboard' /> */}
        <Redirect exact from='/' to='/newMessage/normalMessage' />
        
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
